import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { Battery } from "@/components/sections/Battery";
import { Process } from "@/components/sections/Process";
import { FinalCta } from "@/components/sections/FinalCta";
import { LeadForm } from "@/components/sections/LeadForm";
import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const CONSIDER = [
  { t: "New or existing solar", d: "Batteries can be paired with a new installation or added to many existing systems." },
  { t: "What you want backed up", d: "We'll talk through which circuits and appliances matter most to you during an outage." },
  { t: "Equipment compatibility", d: "We work with leading platforms including Tesla and Enphase energy storage solutions." },
  { t: "Your electrical system", d: "We evaluate your panel and wiring so storage is integrated safely and correctly." },
];

const Considerations = () => (
  <section data-testid="battery-considerations" className="bg-[#0b0c0e] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <SectionHead index="02" eyebrow="Planning Storage" lines={["What we look at", "with you"]} sub="Every home is different. These are some of the things we review before recommending a battery option." />
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CONSIDER.map((c, i) => (
          <Reveal key={c.t} delay={i * 0.08} className="card-lux rounded-2xl p-7" data-testid={`battery-consider-${i}`}>
            <span className="font-mono text-xs text-amber-400">0{i + 1}</span>
            <h3 className="mt-8 text-base font-semibold uppercase text-white">{c.t}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-300">{c.d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default function BatteriesPage() {
  return (
    <main data-testid="batteries-page">
      <Seo path="/solar-batteries" title="Solar Battery Installation in Texas | Solar Energy Doc"
        description="Solar battery installation across Texas. Store excess solar energy and add backup power with professionally installed storage from a licensed, Tesla and Enphase certified team." />
      <PageHero eyebrow="Solar Batteries · Texas" service="Solar Battery" testId="batteries-page-hero" lines={["Store your power.", "Use it your way."]}
        sub="Battery storage can help store excess solar energy, support backup power and give you more control over how and when your home uses energy." />
      <Battery index="01" />
      <Considerations />
      <Process />
      <FinalCta />
      <LeadForm />
    </main>
  );
}
